import {
  PermissionCode,
  useHasPermissionForDescription,
  useHasPermissionForGroup,
} from '@atlas-frontend/sdk';
import { useMemo } from 'react';
import { SampleDataObjectType } from '../sample/SampleSearch';

export const useHasPermissionToManageSample = (
  id: number,
  sampleType: SampleDataObjectType,
  permissionCode: PermissionCode = PermissionCode.SAMPLE_MANAGE
) => {
  const hasPermissionToManageInputDataDescription =
    useHasPermissionForDescription();
  const hasPermissionToManageInputDataGroup = useHasPermissionForGroup();

  return useMemo(
    () =>
      (sampleType === 'group'
        ? hasPermissionToManageInputDataGroup
        : hasPermissionToManageInputDataDescription)(permissionCode, id),
    [
      hasPermissionToManageInputDataGroup,
      hasPermissionToManageInputDataDescription,
      id,
      sampleType,
      permissionCode,
    ]
  );
};
